export const sortItem = { sortKey: 'Ranking', sortOrder: 'asc' };
